import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MsalGuard } from '@azure/msal-angular';
import { AdminGuard } from './helpers/guards/admin.guard';
import { UserResolver } from './helpers/resolvers/user.resolver';
import { UnsavedChangesGuard } from './helpers/guards/unsaved-changes.guard';
import { ProjectConfigurationComponent } from './pages/project-configuration/project-configuration.component';
import { ProjectConfigurationSummaryComponent } from './pages/project-configuration-summary/project-configuration-summary.component';
import { NotificationCenterComponent } from './pages/notification-center/notification-center.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { SignoutOidcComponent } from './pages/signout-oidc/signout-oidc.component';
import { ProjectConfigDataResolver } from './helpers/resolvers/project-config-data.resolver';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ExternalClientComponent } from './pages/project/external-client/external-client.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    canActivate: [],
    component: DashboardComponent,
    data: {
      breadcrumb: null,
    },
    resolve: { user: UserResolver },
  },
  {
    path: 'profile',
    canActivate: [MsalGuard],
    component: ProfileComponent,
    data: { breadcrumb: 'Profile' },
    resolve: { user: UserResolver },
  },
  {
    path: '',
    canActivate: [MsalGuard],
    canActivateChild: [AdminGuard],
    loadChildren: () => import('./pages/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '',
    loadChildren: () => import('./pages/project/project.module').then((m) => m.ProjectModule),
  },
  {
    path: 'project-configuration/:id',
    canActivate: [],
    component: ProjectConfigurationComponent,
    data: { breadcrumb: 'Project Configuration' },
    resolve: { user: UserResolver, configData: ProjectConfigDataResolver },
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'project-configuration/summary/:id',
    canDeactivate: [UnsavedChangesGuard],
    canActivate: [],
    component: ProjectConfigurationSummaryComponent,
    data: { breadcrumb: 'Project Configuration' },
    resolve: { user: UserResolver, configData: ProjectConfigDataResolver },
  },
  {
    path: 'project-configuration/external-client/:id',
    canActivate: [],
    component: ExternalClientComponent,
    data: {
      breadcrumb: 'External Client'
    },
  },
  {
    path: 'notification-center',
    canActivate: [MsalGuard],
    component: NotificationCenterComponent,
    data: { breadcrumb: 'Notification Center' },
    resolve: { user: UserResolver },
  },
  {
    path: 'no-access',
    canActivate: [],
    component: UnauthorizedComponent,
    data: {
      breadcrumb: null,
    },
  },
  {
    path: 'signout-oidc',
    canActivate: [],
    component: SignoutOidcComponent,
    data: {
      breadcrumb: null,
    },
  },
  {
    path: 'not-found',
    canActivate: [],
    component: NotFoundComponent,
    data: {
      breadcrumb: null,
    },
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
  {
    path: 'not-found',
    canActivate: [],
    component: NotFoundComponent,
    data: {
      breadcrumb: null,
    },
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
  {
    path: 'not-found',
    canActivate: [],
    component: NotFoundComponent,
    data: {
      breadcrumb: null,
    },
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
